Date.prototype.yyyymmdd = function () {
  let year = this.getFullYear().toString();
  let month = (this.getMonth() + 1).toString();
  let day = this.getDate().toString();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join("-");
};

Date.prototype.isWeekend = function () {
  return this.getDay() === 0 || this.getDay() === 6;
};

Date.prototype.getWeek = function () {
  const jan1st = new Date(this.getFullYear(), 0, 1);
  return Math.ceil(((this - jan1st) / 86400000 + jan1st.getDay() + 1) / 7);
};
